import { getInlineBackgroundColor, getInlineColor } from "elements/progressBar";
import './style.css'
import { useRef } from "react";
import { PlagiarismData } from "../types";
import {splitIntoSentences} from "utils";

interface IBuildSentence{
    sentence: string;
    backgroundColor: string;
    color: string;
    score: number;
    selectedSentences: string[];
}

const BuildSentence: React.FC<IBuildSentence> = (props) => {
    const {sentence, score, selectedSentences} = props;
    const containerRef = useRef(null);

    const filteredSelectedSentences = selectedSentences.map(sentence => sentence.toLowerCase().replace(/[^a-z]/g, ''));
    const filteredSentence = sentence.toLowerCase().replace(/[^a-z]/g, '');
    console.log(filteredSelectedSentences, "filteredSelectedSentences", filteredSentence);
    var className = "tooltip__parent ";
    var isSelected = false;
    for (const filteredSelectedSentence of filteredSelectedSentences) {
        if (filteredSentence.includes(filteredSelectedSentence) && filteredSelectedSentence !== '') {
            className += "selected__sentence";
            isSelected = true;
            break;
        }
    }
    if (!isSelected) {
        className += score < 40 ? 'tooltip__parent-green' : score < 60 ? 'tooltip__parent-yellow' : 'tooltip__parent-red';
    }

    return <span style={{
        }}
            ref={containerRef}
            className={className}
            dangerouslySetInnerHTML={{__html: sentence}}
        />
}

interface IBuildSegments {
    data: {text: string, backgroundColor: string, color: string, score: number}[]
    selectedSentence: string[];
}

export const BuildSegments: React.FC<IBuildSegments> = (props) => {
    const {data, selectedSentence} = props;
    return <>
        {
            data.map(
                (e) => <BuildSentence 
                    sentence={e.text}
                    backgroundColor={e.backgroundColor}
                    score={e.score}
                    color={e.color}
                    selectedSentences={selectedSentence}
                />
            )
        }
    </>
}

function summarizeScores(text: string, segments: number[]) {
    var sentences = []
    var splitted = text.replaceAll('. ', '|||').split(' ');
    if (splitted.length === 1) {
        return {sentenceScores: [segments.reduce((p, n) => p + n) / segments.length], sentences: []}
    }
    var sentenceScores: number[] = []
    var sum = 0;
    var len = 0;
    var sentence = "";
    for (var i = 0; i < Math.min(splitted.length, segments.length); ++i) {
        var e = splitted[i];
        if (e.indexOf('|||') !== -1 || e.indexOf('.\n') !== -1) {
            sentenceScores.push(sum / len);
            sum = 0;
            len = 0;
            sentences.push(sentence);
        }
        sum += segments[i];
        sentence += e;
        len += 1;
        
    }
    if (len !== 0) {
        sentenceScores.push(sum / len);
        sentences.push(sentence)
    }
    return {sentenceScores, sentences};
}

export function buildSentenceTooltipStyle(active: boolean) {
    return `display: ${active ? "inline-flex" : "none"};
    position: absolute;
    background-size: 102px 36px;
    width: 102px;
    height: 36px;
    background-repeat: no-repeat;
    justify-content: center;
    align-items: center;
    transform: translateY(-8px);
    user-select: none;
    `
}

export function mapSegments(text: string, segments: number[]) {
    if (text.endsWith('.')) {
        text = text.slice(0, text.length-1);
    }
    var splitted = text.replaceAll('\n', '<br>').split(/\./);
    var {sentenceScores, sentences} = summarizeScores(text, segments);

    const validScores = sentenceScores.filter(score => !Number.isNaN(score));
    const avg = validScores.length > 0 
        ? validScores.reduce((e, v) => e + v) / validScores.length 
        : 50;

    return splitted.map((e, index) => 
        {
            var r = sentenceScores[index] * 100;
            if (Number.isNaN(r)) {
                r = avg * 100;
            }
            var shouldAddDot = index < splitted.length - 1;
            return {
                'text': `${e}${shouldAddDot ? '.' : ''}
                    <div class="div__tooltip">
                        <div
                            contentEditable="false"
                            style="
                                ${buildSentenceTooltipStyle(false)}
                            " class="segmentation-tooltip ${r < 40 ? "good__tooltip" : r < 60 ? "medium__tooltip" : "bad__tooltip"}">${r.toFixed(2)}% AI
                        </div>
                    </div>
                    
                `, 
                'backgroundColor': getInlineColor(r),
                'color': getInlineBackgroundColor(r),
                'score': r
            }
        })
}


    
function splitByPlagiated(text: string, plagiatedTexts: {text: string, probability: number}[]) {
    const result: Array<{text: string, type: "plagiat" | "original", probability?: number}> = [];

    const plagiatSentences = new Map<string, number>();
    const textProbabilities = new Map<string, number[]>();
    
    for (const plagText of plagiatedTexts) {
        const normalized = plagText.text.toLowerCase().replace(/[^a-zа-я]/g, '');
        if (normalized) {
            if (!textProbabilities.has(normalized)) {
                textProbabilities.set(normalized, []);
            }
            const probArray = textProbabilities.get(normalized);
            if (probArray) {
                probArray.push(plagText.probability);
            }
        }
    }
    
    const normalizedTexts = Array.from(textProbabilities.keys());
    for (let i = 0; i < normalizedTexts.length; i++) {
        const normalized = normalizedTexts[i];
        const probabilities = textProbabilities.get(normalized);
        if (probabilities && probabilities.length > 0) {
            let sum = 0;
            for (let j = 0; j < probabilities.length; j++) {
                sum += probabilities[j];
            }
            const average = sum / probabilities.length;
            plagiatSentences.set(normalized, average);
        }
    }

    const delimiters = /([.])/;
    const parts = splitIntoSentences(text);

    let currentSentence = "";
    for (let i = 0; i < parts.length; i++) {
        currentSentence += parts[i];
        if (delimiters.test(parts[i]) || i === parts.length - 1) {
            if (/\S/.test(currentSentence)) {
                const trimmedSentence = currentSentence.trim();
                const normalized = trimmedSentence.toLowerCase().replace(/[^a-zа-я]/g, '');
                let matchingProbabilities = [];
                for (const plagiatSentence of Array.from(plagiatSentences.keys())) {
                    if (normalized.includes(plagiatSentence)) {
                        matchingProbabilities.push(plagiatSentences.get(plagiatSentence)!);
                    }
                }
                console.log(matchingProbabilities, "matchingProbabilities", normalized);
                const probability = matchingProbabilities.length > 0 
                    ? matchingProbabilities.reduce((sum, prob) => sum + prob, 0) / matchingProbabilities.length 
                    : 0;
                    
                if (probability !== 0) {
                    result.push({
                        text: currentSentence,
                        type: "plagiat",
                        probability: probability
                    });
                } else {
                    result.push({
                        text: currentSentence,
                        type: "original"
                    });
                }
            }
            currentSentence = "";
        }
    }
    return result;
}



function plagiarismDataToTexts(plagiarismData: PlagiarismData): Array<{text: string, probability: number}> {
    const plagiarizedSentences: Array<{text: string, probability: number}> = [];
    
    for (const result of plagiarismData.results) {
        for (const score of result.scores) {
            plagiarizedSentences.push({
                text: score.phrase,
                probability: score.score
            });
        }
    }
    
    return plagiarizedSentences;
}

export function mapPlagiarismSegments(text: string, plagiarismData: PlagiarismData) {
    // if (text.endsWith('.')) {
    //     text = text.slice(0, text.length-1);
    // }
    if (!text.endsWith('.')) {
        text += '.';
    }
    text = text.replaceAll('\n', '<br>');
    var mappedTexts: any = splitByPlagiated(text, plagiarismDataToTexts(plagiarismData));
    console.log(mappedTexts, "mappedTexts");
    mappedTexts = mappedTexts.map((e: any, index: number) => {
        return {
            'text': e.text,
            'backgroundColor': e.type === "plagiat" ? getInlineColor(100) : getInlineColor(0),
            'color': e.type === "plagiat" ? getInlineBackgroundColor(100) : getInlineBackgroundColor(0),
            'score': e.probability * 100 || 0,
        }
    })
    return mappedTexts.map((e: any, index: number) => 
        {
            var r = e.score;
            return {
                'text': `${e.text}
                    <div class="div__tooltip">
                        <div
                            contentEditable="false"
                            style="
                                ${buildSentenceTooltipStyle(false)}
                            " class="segmentation-tooltip ${r < 40 ? "good__tooltip" : r < 60 ? "medium__tooltip" : "bad__tooltip"}">${r.toFixed(2)}% AI
                        </div>
                    </div>
                    
                `, 
                'backgroundColor': getInlineColor(r),
                'color': getInlineBackgroundColor(r),
                'score': r
            }
        })
}